import React from 'react'
import Form from '../2/Controls/Form';
import Input from '../2/Controls/Input';
import Window from '../2/Controls/Window';
import { getHelpDeskProrites } from '../../CommonFunctions';

class AddEditHelpDeskType extends React.Component {
    constructor(props) {
        super(props)  // ✅ Fixed: pass props to super
        this.state = {
            key: props.editData && props.editData.hasOwnProperty('key') ? props.editData.key : null,
            Type: props.editData && props.editData.hasOwnProperty('Type') ? props.editData.Type : '',
            SubTypes: props.editData && props.editData.hasOwnProperty('SubTypes') ? props.editData.SubTypes : [],
            Settings: props.editData && props.editData.hasOwnProperty('Settings') ? props.editData.Settings : {
                IsRequireProduct: false,
                IsRequireOrder: false,
                DefaultPriority:"Low",
            },
            newSubTypeName: '',
            saving: false
        }
    }

    onSave = () => {
        if (!this.state.Type.trim()) {
            alert('Please enter Type name');
            return;
        }

        const saveData = {
            Type: this.state.Type,
            SubTypes: this.state.SubTypes,
            Settings: this.state.Settings
        };

        this.setState({ saving: true });
        this.props.saveHelpDeskType(saveData, this.state.key).then((key) => {
            this.props.getToastr("Type Saved Successfully");
            this.setState({ saving: false });
            this.props.onSave();
        }).catch((error) => {
            // ✅ Add error handling
            this.props.getToastr("Error saving type", "error");
            this.setState({ saving: false });
        });
    }

    addSubType = () => {
        if (!this.state.newSubTypeName.trim()) {
            alert('Please enter SubType name');
            return;
        }

        const exists = this.state.SubTypes.some(sub => sub.Name === this.state.newSubTypeName.trim());
        if (exists) {
            alert('SubType already exists');
            return;
        }

        const newSubType = {
            Name: this.state.newSubTypeName.trim()
        };

        this.setState({
            SubTypes: [...this.state.SubTypes, newSubType],
            newSubTypeName: ''
        });
    }

    removeSubType = (index) => {
        const updatedSubTypes = [...this.state.SubTypes];
        updatedSubTypes.splice(index, 1);
        this.setState({ SubTypes: updatedSubTypes });
    }

    updateSubType = (index, newName) => {
        if (!newName.trim()) return;

        const updatedSubTypes = [...this.state.SubTypes];
        updatedSubTypes[index] = {
            Name: newName.trim()
        };
        this.setState({ SubTypes: updatedSubTypes });
    }

    renderSubTypes = () => {
        return (
            <div style={{ marginBottom: '20px' }}>
                <label>SubTypes</label>
                <div style={{ marginBottom: '10px' }}>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter SubType name"
                            value={this.state.newSubTypeName}
                            onChange={(e) => this.setState({ newSubTypeName: e.target.value })}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    this.addSubType();
                                }
                            }}
                            style={{ flex: 1 }}
                        />
                        <button
                            className="btn btn-primary"
                            onClick={this.addSubType}
                            type="button"
                        >
                            Add SubType
                        </button>
                    </div>
                </div>

                {this.state.SubTypes.length > 0 && (
                    <div style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        maxHeight: '300px',
                        overflowY: 'auto'
                    }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ backgroundColor: '#f5f5f5' }}>
                                <tr key="header">
                                    <th key="name" style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>SubType Name</th>
                                    <th key="action" style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid #ddd', width: '80px' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.SubTypes.map((subType, index) => (
                                    <tr key={subType.Id || index}>
                                        <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={subType.Name}
                                                onChange={(e) => this.updateSubType(index, e.target.value)}
                                                style={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ padding: '8px', textAlign: 'center', borderBottom: '1px solid #eee' }}>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => this.removeSubType(index)}
                                                style={{ padding: '4px 8px', fontSize: '12px' }}
                                                type="button"
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {this.state.SubTypes.length === 0 && (
                    <div style={{
                        padding: '20px',
                        textAlign: 'center',
                        color: '#999',
                        border: '1px dashed #ddd',
                        borderRadius: '4px'
                    }}>
                        No subtypes added yet. Click "Add SubType" to add.
                    </div>
                )}
            </div>
        );
    }

    render() {
        return (
            <Window
                header={this.state.key ? "Edit Type" : "New Type"}
                onButtonClick={(action) => {
                    if (action.toLowerCase() === "save") {
                        this.onSave();
                    } else {
                        this.props.onClose();
                    }
                }}
                buttons={[
                    { Type: "secondary", Text: "Cancel", Align: "left" },
                    { Type: "primary", Text: "Save", Align: "right" },
                ]}
                processing={this.state.saving}
                onClose={() => this.props.onClose()}
                slide={true}
            >
                <div>
                    <Input
                        type="text"
                        label="Type Name"
                        placeholder="Enter help desk type name"
                        value={this.state.Type}
                        onChange={(value) => this.setState({ Type: value })}
                        required={true}
                    />

                    {this.renderSubTypes()}

                    <Input
                        type="switch"
                        label="Require Product"
                        value={this.state.Settings.IsRequireProduct || false}
                        onChange={() =>
                            this.setState({
                                Settings: {
                                    ...this.state.Settings,
                                    IsRequireProduct: !this.state.Settings.IsRequireProduct
                                }
                            })
                        }
                    />

                    <Input
                        type="switch"
                        label="Require Order"
                        value={this.state.Settings.IsRequireOrder || false}
                        onChange={() =>
                            this.setState({
                                Settings: {
                                    ...this.state.Settings,
                                    IsRequireOrder: !this.state.Settings.IsRequireOrder
                                }
                            })
                        }
                    />

                    <div >
                        <label style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px", display: "block" }}>
                          Priority
                        </label>
                        <Input
                          type="select"
                          value={this.state.Settings.DefaultPriority}
                          onChange={(e)=>{
                            console.log("E",e);
                                this.setState({
                                Settings: {
                                    ...this.state.Settings,
                                    DefaultPriority:e
                                }
                            })
                          }}
                        >
                          {getHelpDeskProrites.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </div>
                </div>
            </Window>
        );
    }
}

export default AddEditHelpDeskType;